import app from 'flarum/common/app';
app.initializers.add('ideasynq-handles-common', () => {
  console.log('[ideasynq/flarum-handles] Hello, forum and admin!');
});